import React, { useEffect, useRef } from "react";
import { CardIcon } from "../../utils/Icons";
import "./deck.css";
import { DeckProps } from "../../GameTypes/game.type";

const Deck: React.FC<DeckProps> = ({ setRef, cardSize }) => {
  const deckCardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (setRef && deckCardRef.current) {
      setRef(deckCardRef.current);
    }
  }, [setRef]);

  return (
    <>
      <div className="game-deck-wrapper">
        <div className="game-deck-layout">
          {[...Array(4)].map((_, index) => (
            <div className="game-deck-container" key={index}>
              <div className="game-deck-card game-deck-card-back">
                <div className="game-deck-card-bg">
                  <CardIcon />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div
        ref={deckCardRef}
        className="moving-card"
        style={{ width: `${cardSize.width}px`, height: `${cardSize.height}px` }}
      >
        <div className="game-deck-container">
          <div className="game-deck-card game-deck-card-back">
            <div className="game-deck-card-bg">
              <CardIcon />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Deck;